module.exports = "https://de18y2hs3hlxs.cloudfront.net/55a5b72b-ea57-45f3-9ae4-45ca394141b9/images/LogoHorizontal_White.svg?9c112b852f8360595639d7074f825d62";